<div class="row mt-3 mb-2">
  <div class="col-12">
    <h2 class="float-left">
      <a href="#" class="arrow-back" wcag-dummy-link-target role="button" aria-label="Back"
        (click)="returnPreviousLocation($event)" (keypress)="returnPreviousLocation($event)">
        <fa-icon class="float-left back-icon" [icon]="['fas', 'chevron-left']"></fa-icon>
        <span style="display: none">back</span>
      </a>
      {{ 'COMMON.historyList.' + tableDetails.title | translate }}
    </h2>
  </div>
</div>

<app-simple-table-wrapper [tableDetails]="tableDetails"></app-simple-table-wrapper>